<template>
  <svg viewBox="0 0 10 10" fill="currentColor">
    <polygon points="1,3 5,7 9,3"/>
  </svg>
</template>
